'use client'
import React from 'react';
import styled from 'styled-components';
import ReactHtmlParser from "react-html-parser";
import {title} from "@/styles/globalStyleVars";

const Description = ({
                   text,
                   fontSize,
                   fontWeight,
                   color,
                   letterSpacing,
                   lineHeight,
                   textTransform,
                   margin,
                   padding,
                   borderColor,
                   varient,
                   center,
                   classname,
                   marginSm,
                   width
               }) => {


    return (

        <StyledTitle className={`description ${classname}`}
                     fontSize={fontSize}
                     fontWeight={fontWeight}
                     color={color}
                     lineHeight={lineHeight}
                     LetterSpacing={letterSpacing}
                     textTransform={textTransform}
                     margin={margin}
                     padding={padding}
                     varient={varient}
                     center={center}
                     marginSm={marginSm}
                     width={width}
                     borderColor={borderColor}>
            <p className={''}>{ReactHtmlParser(text)} </p>


        </StyledTitle>

    )
};


const StyledTitle = styled.div`
  margin: ${props => props.margin || '0px'};
  position: relative;
  width: ${props => props.width || 'fit-content'};
  font-family: ${title};
  text-align: ${props => props?.center ? 'center' : ''};
  padding: ${p => p.padding};

  p {
    font-size: ${props => props.fontSize || 16}px;
    line-height: ${props => props.lineHeight || 24}px;
    //text-transform: uppercase;
    font-weight: ${props => props.fontWeight || '500'};
    color: ${props => props.color || "#3C3C3B"};
      &:not(:last-child){
          margin-bottom: 24px;
      }
  }
    
    @media(min-width: 1920px){
        p{
            font-size: 18px;
            line-height: 27px;
        }
    }
  @media (max-width: 767px) {
    padding: 0;
    margin: ${p => p.marginSm};
  }
`;


export default Description;














